import httpClient from './httpClient';

class ProcessTemplateService {
  constructor() {
    this.baseURL = '/api/process-templates';
  }

  /**
   * Get all process templates
   */
  async getTemplates() {
    try {
      const response = await httpClient.get(this.baseURL);
      const data = response.data?.data || response.data;
      return data.items || data;
    } catch (error) {
      console.error('Error fetching process templates:', error);
      throw error;
    }
  }

  /**
   * Get a specific process template by ID
   */
  async getTemplate(id) {
    try {
      const response = await httpClient.get(`${this.baseURL}/${id}`);
      return response.data?.data || response.data;
    } catch (error) {
      console.error(`Error fetching process template ${id}:`, error);
      throw error;
    }
  }

  /**
   * Create a new process template
   */
  async createTemplate(data) {
    try {
      const response = await httpClient.post(this.baseURL, data);
      return response.data?.data || response.data;
    } catch (error) {
      console.error('Error creating process template:', error);
      throw error;
    }
  }

  /**
   * Update an existing process template
   */
  async updateTemplate(id, data) {
    try {
      const response = await httpClient.put(`${this.baseURL}/${id}`, data);
      return response.data?.data || response.data;
    } catch (error) {
      console.error(`Error updating process template ${id}:`, error);
      throw error;
    }
  }

  /**
   * Delete a process template
   */
  async deleteTemplate(id) {
    try {
      const response = await httpClient.delete(`${this.baseURL}/${id}`);
      return response.data?.data || response.data;
    } catch (error) {
      console.error(`Error deleting process template ${id}:`, error);
      throw error;
    }
  }
}

const processTemplateService = new ProcessTemplateService();
export default processTemplateService;
